// ~/util/findCategoryAndSubcategory.js
import { vegetables } from './montenegro/vegetables'
import { croatia } from './croatia/croatia'
import { bih } from './bih/bih'
import { seeds } from './seeds/seeds'
import { products } from './ns/products'
import { abattoirs } from './eu/abattoirs'
import { pesticides } from './pesticides/pesticides'

// map: ulazni "source" -> naziv kolekcije u importu
const DATASET_NAME_MAP = {
  croatia: 'croatia',
  montenegro: 'vegetables',
  products: 'products',
  abattoirs: 'abattoirs',
  pesticides: 'pesticides',
  seeds: 'seeds',
  bih: 'bih',
}

// map: naziv kolekcije -> realni import
const DATASETS = {
  croatia,
  bih,
  products,
  abattoirs,
  pesticides,
  seeds,
  vegetables,
}

// helper: na osnovu sourceKey vrati niz kategorija
function resolveCollection(sourceKey) {
  const datasetName = DATASET_NAME_MAP[sourceKey]


  if (!datasetName) return []

  const raw = DATASETS[datasetName]


  if (!raw) return []


  return Array.isArray(raw) ? raw : []
}

/**
 * findCategory
 * @param {Object} params { category, source }
 * @param {Function} slugifyFn funkcija koja prima string i vraca slug
 */
export function findCategory(params, slugifyFn) {
  const { category, source = 'seeds' } = params

  const collection = resolveCollection(source)

  if (!collection.length) return false

  // ako nema category, vrati celu kolekciju
  if (category == null) return collection

  const match = collection.find((x) => slugifyFn(x.text) === category)
  return match || false
}

/**
 * findSubcategory
 * @param {Object} params { category, subcategory, source }
 * @param {Function} slugifyFn
 */
export function findSubcategory(params, slugifyFn) {
  const { subcategory } = params

  const categoryObj = findCategory(params, slugifyFn)
  if (!categoryObj || !Array.isArray(categoryObj.subcategories)) return false

  const match = categoryObj.subcategories.find(
    (x) => slugifyFn(x.text) === subcategory
  )

  return match || false
}

export function findYear(params) {
  try {
    // očekuješ npr. "01.01.2025 do 07.01.2025"
    const week = params.week.split('do')
    return week[0].split('.')[2].split('-').join('')
  } catch (error) {
    return new Date().getFullYear()
  }
}
